/**
 * 10.7B — TestPad: portal de TESTE de combate no Santuário. Interagir spawna 1 de cada
 * inimigo do jogo em anel ao redor do Caçador, para stress-test do balanceamento.
 * Não é conteúdo de jogo: só valida números (dano, HP, Threat, drop, upgrades comprados).
 */
import * as THREE from "three";
import { makeLabel } from "./StructureLabel";
import { crystalStdMat, energyMat, platformMat } from "./Materials";

export class TestPad {
  readonly group = new THREE.Group();
  private readonly pos: THREE.Vector3;
  private ring!: THREE.Mesh;
  private crystal!: THREE.Mesh;
  private time = 0;

  constructor(scene: THREE.Scene, position: { x: number; z: number }) {
    this.pos = new THREE.Vector3(position.x, 0, position.z);
    this.buildMesh();
    this.group.position.copy(this.pos);
    scene.add(this.group);
  }

  get position(): THREE.Vector3 { return this.pos; }

  setVisible(v: boolean): void { this.group.visible = v; }

  isPlayerNear(playerPos: THREE.Vector3, radius = 2.5): boolean {
    return playerPos.distanceTo(this.pos) <= radius;
  }

  update(dt: number): void {
    this.time += dt;
    if (this.ring) this.ring.rotation.y = this.time * 0.8;
    if (this.crystal) {
      this.crystal.position.y = 1.2 + Math.sin(this.time * 2.2) * 0.12;
      this.crystal.rotation.y = this.time * 1.4;
    }
  }

  private buildMesh(): void {
    // base — plataforma redonda escura com bordas brilhantes
    // 10.9BQ — tudo da biblioteca (nada anima material aqui: anel/cristal só giram/flutuam)
    const base = new THREE.Mesh(new THREE.CylinderGeometry(1.4, 1.5, 0.2, 24), platformMat(0x3a1a5a, 0.35));
    base.position.y = 0.1;
    this.group.add(base);

    // runa circular no chão (aditiva, girando)
    this.ring = new THREE.Mesh(new THREE.RingGeometry(1.5, 1.85, 24, 1, 0, Math.PI * 1.7), energyMat(0xff7a3c, "ring"));
    this.ring.rotation.x = -Math.PI / 2;
    this.ring.position.y = 0.05;
    this.group.add(this.ring);

    // cristal central flutuando (indica "aperte pra testar") — pequeno: sem sombra
    this.crystal = new THREE.Mesh(new THREE.OctahedronGeometry(0.35, 0), crystalStdMat(0xff9060, 0xff5028, 1.4));
    this.crystal.position.y = 1.2;
    this.group.add(this.crystal);

    // pilar de luz sutil
    const beam = new THREE.Mesh(new THREE.CylinderGeometry(0.6, 0.9, 3.2, 12, 1, true), energyMat(0xff6040, "glow"));
    beam.position.y = 1.6;
    this.group.add(beam);

    // 10.9B — rótulo flutuante
    this.group.add(makeLabel("🧪 Teste", "#ff7a3c", 3.4));
  }
}
